module.exports = __webpack_public_path__ + "img/nut-pistachios-350x184.5d3a262b.jpg";